import { DOC_FLOW_UPLOADING_ENTITY } from '../../../constants/entity'
import {
  FilesPreviewGallery,
  useFilePreviewGallery,
} from '../../FilesPreviewGallery'
import { PageLoader } from '../../Page'
import { TableDnDSortableBody } from '../../Table'
import { useUploadingPhase } from '../DocFlow.hooks'
import { DocFlowPhaseTable } from '../DocFlowPhaseTable'
import { DocFlowUploadingTableRow } from '../DocFlowUploadingTableRow'

import { updateTableConfig } from './DocFlowUploading.api'
import { DOC_FLOW_UPLOADING_TABLE_ACTIONS_COLUMN_WIDTH } from './DocFlowUploading.constants'
import {
  getMassActions,
  getUploadingTableItemActions,
} from './DocFlowUploading.utils'

function DocFlowUploading() {
  const {
    emptyStateActions,
    files,
    handleDragEnd,
    handleOpenChangeTypeModal,
    previewFiles,
    selectionData,
    setItemAction,
    setMassAction,
    tableItems,
    updatedRows,
    uploadingTableLoader,
  } = useUploadingPhase()

  const { handleReload, isRefetching } = uploadingTableLoader

  const { activeFileIndex, handleClickFile, handleCloseFilePreview } =
    useFilePreviewGallery({
      files,
    })

  return (
    <>
      {isRefetching ? <PageLoader /> : null}
      <DocFlowPhaseTable
        TableFilterBar={null}
        TableRow={DocFlowUploadingTableRow}
        emptyStateActions={emptyStateActions}
        emptyStateText='DocumentStapling.UploadingTableNoDataKey'
        entity={DOC_FLOW_UPLOADING_ENTITY}
        getActions={getUploadingTableItemActions}
        getMassActions={getMassActions}
        items={updatedRows || tableItems}
        selectionData={selectionData}
        setItemAction={setItemAction}
        setMassAction={setMassAction}
        tableLoader={uploadingTableLoader}
        tableProps={{
          TableBody: TableDnDSortableBody,
          actionsColumnWidth: DOC_FLOW_UPLOADING_TABLE_ACTIONS_COLUMN_WIDTH,
          bodyProps: {
            droppableProps: {
              items: updatedRows || tableItems,
              onDragEnd: handleDragEnd,
            },
          },
        }}
        tableRowProps={{
          onClickFile: handleClickFile,
          onOpenChangeTypeModal: handleOpenChangeTypeModal,
          onReloadTable: handleReload,
        }}
        updateTableConfig={updateTableConfig}
      />
      <FilesPreviewGallery
        files={previewFiles}
        initActive={activeFileIndex}
        onClose={handleCloseFilePreview}
      />
    </>
  )
}

export default DocFlowUploading
